import { useApi } from '@/composables/useApi'

const api = useApi()

export default {
  namespaced: true,
  state: {
    loading: false,
    pagamento: null,
    pagamentos: [],
  },
  getters: {
    loading: state => state.loading,
    pagamento: state => state.pagamento,
    pagamentos: state => state.pagamentos,
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload
    },
    SET_PAGAMENTO(state, payload) {
      state.pagamento = payload
    },
    SET_PAGAMENTOS(state, payload) {
      state.pagamentos = payload
    },
  },
  actions: {
    findAll({ commit }, queryParams) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', true)
        api.get('/pagamentos', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
            .finally(() => commit('SET_LOADING', false))
      })
    },
    primeiraCobranca({ commit }, {id, data}) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', true)
        api.post(`/pagamentos/primeira-cobranca/${id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
            .finally(() => commit('SET_LOADING', false))
      })
    },
    segundaCobranca({ commit }, {id, data}) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', true)
        api.post(`/pagamentos/segunda-cobranca/${id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
            .finally(() => commit('SET_LOADING', false))
      })
    },
    bloqueiaUsuario({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', true)
        api.post(`/pagamentos/bloqueia-usuario/${payload.id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
            .finally(() => commit('SET_LOADING', false))
      })
    },
  },
}
